export default __webpack_public_path__ + "static/slider-6-3758efbacc15e0c5aa801e81217b7899.jpg";